// extracted by mini-css-extract-plugin
module.exports = {"center":"AssetProviderPage_center__2zzuz","fullWidth":"AssetProviderPage_fullWidth__2Iw-3"};